import {container} from 'app/ioc';

const useInjection = <T>(key: symbol): T => {
    return container.get<T>(key);
};

export default useInjection;
